import { render, staticRenderFns } from "./AnimationTimer.vue?vue&type=template&id=bfc31b4e&"
import script from "./AnimationTimer.vue?vue&type=script&lang=js&"
export * from "./AnimationTimer.vue?vue&type=script&lang=js&"
import style0 from "./AnimationTimer.vue?vue&type=style&index=0&id=bfc31b4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports